import { createFileRoute } from '@tanstack/react-router';
import NotFound from '../../../pages/notFound/NotFound';

export const Route = createFileRoute('/_authenticated/_navbar/$')({
  component: NotFound,
});
